<app-data-table mainTitle="Logs"
                singleTitle="Log"
                application="proof"
                routerPath="/log"
                entityPath="/authlog"
                [entity]="authLog"
                [columns]="this['columns']">
</app-data-table>
